var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-tr',_vm._l((_vm.record),function(value,key,idx){return _c('b-td',{key:idx,class:[
      _vm.tableColumnsAlign(key),
      // record.account_name?.startsWith('Receivables from') ? 'font-weight-bold bg-gradient' : '',
    ]},[_vm._v(" "+_vm._s(value)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }